import React from 'react';
import ScrollToTop from '../components/ScrollToTop';
import SEO from '../components/SEO';


const KidsProgramQuestionnairePage = () => {
    return (
        <>
            <SEO 
                title="Weflare - HTML Course Registration"
                description="Register for our HTML coding course designed for kids. Join our interactive programming education program."
                keywords="HTML course registration, coding for kids signup, programming education, children technology course"
            />
            <ScrollToTop />
            <div className="container-fluid py-5">
                <div className="row justify-content-center">
                    <div className='col-12 col-md-10 col-lg-8 col-xl-6'>
                        <h1 className="text1 text-center mb-4">Course Registration</h1>
                        <div className="card-modern p-0 overflow-hidden">
                            <iframe 
                                src="https://docs.google.com/forms/d/e/1FAIpQLSfUWWmd2yUfQiHwCdLWKPvGOIK6LtSTRRjwerGw3EMZzdox1Q/viewform?embedded=true"
                                className='w-100'
                                style={{ 
                                    border: 0,
                                    minHeight: '800px',
                                    height: '100vh'
                                }}
                                title="WeFlare HTML Course Registration Form"
                            >
                                Loading registration form...
                            </iframe>
                        </div>
                    </div>
                </div>
            </div>  
        </>
    )
}

export default KidsProgramQuestionnairePage